import { useNavigate, useSearchParams } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import LoginBackground from './LoginBackground/LoginBackground'
import keycloak from '../../keycloak'

export const SessionTimeOutPage = () => {
	const [searchParams] = useSearchParams()
	const lastPageVisit = searchParams.get('redirectURL')

	return (
		<Box sx={{ height: '100vh', width: '100vw', display: 'flex', overflow: 'hidden' }}>
			<LoginBackground renderSpeed={15} sensibility={0.05} />
			<Box sx={{ position: 'relative', zIndex: '2', margin: 'auto', alignSelf: 'center' }}>
				<Box
					sx={{
						backgroundColor: 'rgba(0,0,0,.65)',
						boxShadow: '0px 3px 6px #00000029',
						borderRadius: '10px',
						width: '546px',
						height: '352px',
						display: 'flex',
						justifyContent: 'space-evenly',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<InfoOutlinedIcon color={'white'} fontSize={'large'} />
						<Typography
							sx={{
								fontFamily: 'Open Sans,Helvetica,Arial,sans-serif',
								color: '#FFFFFF',
								fontSize: '24px',
								marginX: '15px',
							}}
						>
							Session Timeout
						</Typography>
					</Box>
					<Box>
						<Typography
							sx={{
								fontFamily: 'Open Sans,Helvetica,Arial,sans-serif',
								textAlign: 'center',
								fontSize: '20px',
								color: '#FFFFFF',
							}}
						>
							Please back to login again.
						</Typography>
					</Box>
					<Box>
						<Button
							sx={{
								fontFamily: 'Open Sans,Helvetica,Arial,sans-serif',
								width: '284px',
								height: '48px',
								backgroundColor: '#FFFFFF',
								borderRadius: '10px',
								color: '#3A3D41',
								fontSize: '20px',
								fontWeight: '600',
								'&:hover': { backgroundColor: '#FFFFFF', color: '#8c9096' },
							}}
							onClick={async () => {
								if (keycloak) keycloak.login({ redirectUri: lastPageVisit || undefined })
							}}
						>
							Back to login page
						</Button>
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

export default SessionTimeOutPage
